enum DoorType {
  SINGLE = 'SINGLE',
  DOUBLE = 'DOUBLE',
  GARAGE = 'GARAGE',
  GARAGE_DOUBLE = 'GARAGE_DOUBLE',
  INTERIOR = 'INTERIOR',
  INTERIOR_DOUBLE = 'INTERIOR_DOUBLE',
  ENTRY = 'ENTRY',
  PATIO = 'PATIO',
  GLIDING = 'GLIDING',
  FLOOR = 'FLOOR',
  FRONT = 'FRONT',
  EXTERIOR = 'EXTERIOR',
  EXTERIOR_DOUBLE = 'EXTERIOR_DOUBLE',
  ENTRY_WITH_SIDELIGHT = 'ENTRY_WITH_SIDELIGHT',
  SECURITY = 'SECURITY',
  GATE = 'GATE',
}

export interface Point {
  x: number,
  y: number
}

export interface Size {
  width: number
  height: number
}

export enum LightPosition {
  CENTER = 'CENTER',
  LEFT_1 = 'LEFT_1',
  LEFT_2 = 'LEFT_2',
  RIGHT_1 = 'RIGHT_1',
  RIGHT_2 = 'RIGHT_2'
}

export interface ClippedCorners {
  hasClippedCorners?: boolean;
  topLeftBottom?: Point;
  topLeftRight?: Point;
  topRightBottom?: Point;
  topRightLeft?: Point;
}

export interface Corners {
  topLeft: Point;
  topRight: Point;
  bottomRight: Point;
  bottomLeft: Point;
}

export type DoorCorners = Corners & ClippedCorners & {
  index: number;
  doorType: DoorType;
}

export interface RenderOptions {
  drawGlassLayer?: boolean
  flipDoor?: boolean
  showDoor?: boolean
  enabledShadowProfiles?: boolean
  enableShadowInpainting?: boolean
  compositionOperator?: string

  calculateDoorBrightness?: boolean

  shadowInpaintingAlpha?: number
}

export interface RenderResult {
  doorBrightness?: number
}

export interface ProductsAtIndex {
  index: number;
  door?: Product
  products?: Array<Product>
}

export type ProductType = string
export type ProductsMap = Map<number, ProductsAtIndex>;

export interface Product {
  name: string;
  visualisationImageUrl?: string;
  thumbnailUrl?: string;

  productType: ProductType;

  customData?: string;
  visualisationLayer?: number
  renderingContextFilter?: string
  renderingContextFillStyle?: string

  shadowImageUrls?: Map<LightPosition, string>;
  doorType: DoorType;
}

export enum ScenarioType {
  USER = 'USER',
  EXAMPLE = 'EXAMPLE'
}

export interface LightSource {
  location: Point;
  intensity: number;
}

export interface ScenarioImage {
  shortId: string
  image: {
    url?: string
    base64?: string
  }
  shadowImage?: {
    url: string
  }
  lightPosition: LightPosition
  doorType: DoorType,
  corners: Array<DoorCorners>
  type: ScenarioType
  lightSources: Array<LightSource>
}

export class Rectangle {

  constructor(public x: number, public y: number, public width: number, public height: number) {
  }

  containsPoint(x: number, y: number): boolean {
    return x >= this.x && y >= this.y && x < this.x + this.width && y < this.y + this.height;
  }
}

export type VisualizedScenarioImage = {
  scenarioImage: ScenarioImage;
  image: HTMLImageElement;
  size: Size;
  lightPosition: LightPosition
  positionInCanvas: Point;
  scale: number;
  corners: Array<DoorCorners>
  boundsOnScreen: Rectangle;
  lightSources: Array<LightSource>;
}
